// extracted by mini-css-extract-plugin
module.exports = {"component":"SideModuleMenuContent_component__YnvaD","pageContent":"SideModuleMenuContent_pageContent__1R7cb"};